import { Flex, FlexProps } from "@radix-ui/themes";
import { forwardRef } from "react";

export const IconPanel = forwardRef<
  HTMLDivElement,
  FlexProps & { color?: "gray" | "panel" }
>(function IconPanel({ children, style, ...props }, ref) {
  return (
    <Flex
      ref={ref}
      width="32px"
      height="32px"
      align="center"
      justify="center"
      style={{
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: "var(--gray-4)",
        borderRadius: "var(--radius-3)",
        backgroundColor:
          props.color === "panel" ? "var(--color-panel)" : "var(--gray-2)",
        ...style,
      }}
      {...props}
    >
      {children}
    </Flex>
  );
});
